import React, {ComponentType} from "react";
import {IProps} from './types';

import { keys } from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import PlusMinusButton from './index';


const NS='PlusMinusButtonContainer';

const propsKeys: string[] = keys<IProps>();
const ThemeWrap = function(all: IProps) {
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  return ReactUtilsService.containerWrap(
    <PlusMinusButton {...props} />
  );
}
/**
 * Returns properties needed for rendering react2angular
 */
export const R2APlusMinusButton: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  propsKeys as never[]
  ];
